import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV3.value;

export const slider = newCollectionTemplate({
  typeFields: {
    title: "text",
    description: "textarea",
    image: "image",
    alt: "text",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: "boolean",
  },
  itemTemplate: {
    title: "",
    description: "",
    image: "",
    alt: "",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: true,
  },
  type: typeSlider,
  showAsTitle: "title", // only texts fields
  allowUseSet: true,
});

// export const slider1 = {
//   typeFields: {
//     title: "text",
//     description: "textarea",
//     image: "image",
//     alt: "text",
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   itemTemplate: {
//     title: "",
//     description: "",
//     image: "",
//     alt: "",
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   type: typeSlider,
//   showAsTitle: "title", // only texts fields
//   allowUseSet: true,
// };

export const initBlockData = {
  title: "Upgrade to a Lux Express Relax seat",
  collections: {
    [typeSlider]: {
      ...slider,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...slider,
      items: [],
    },
  },
};
